/* istanbul ignore file -- file not needed in testing coverage */
// src/DynatracePlaceholder.jsx
import { useEffect } from 'react';

// Use require here to avoid editor/TS issues with JSON imports in some setups.
// If you prefer `import attrs from './dynatraceAttrs.json'` that's fine too.
let attrs;
try {
  /* eslint-disable import/no-dynamic-require
  -- this allows the app to run even if the JSON file is missing, which can happen in some environments.
  */
  attrs = require('./dynatraceAttrs.json');
} catch (e) {
  // If the JSON is missing, log a friendly message instead of crashing the app. -- needed
  // The app will still render and you can debug the missing file.
  // eslint-disable-next-line no-console -- this is a warning for developers, not an error for users
  console.warn('Dynatrace attrs JSON not found at ./dynatraceAttrs.json');
  attrs = null;
}

const DynatracePlaceholder = () => {
  useEffect(() => {
    if (!attrs || !attrs.src) return;

    // Avoid duplicating the placeholder
    if (document.querySelector('#dynatrace-agent-placeholder')) return;

    const script = document.createElement('script');
    script.type = 'text';
    script.id = 'dynatrace-agent-placeholder';
    script.setAttribute('src', attrs.src);
    if (attrs.integrity) script.setAttribute('integrity', attrs.integrity);
    if (attrs.crossorigin) script.setAttribute('crossorigin', attrs.crossorigin);
    if (attrs.dtconfig) script.setAttribute('data-dtconfig', attrs.dtconfig);

    document.head.appendChild(script);
  }, []);

  // render nothing into the React tree; all work is done in head
  return null;
};

export default DynatracePlaceholder;